import { HeaderStyled } from './header.styled';
import Button from '../../../../../components/base/button/button';
import PersonIcon from '@mui/icons-material/Person';
import i18n from '../../../../../translations/strings';
import { useState } from 'react';
import { Drawer, ListItemButton, ListItemText } from '@mui/material';
import { SvgImage, SvgType } from '../../../../../components/base/svg/svg';
import { useNavigate } from 'react-router-dom';

export interface HeaderLandingPageProps {
  scrollToServices: () => void;
  scrollToFooter: () => void;
  scrollToMap: () => void;
  scrollToRooms: () => void;
}

const HeaderLandingPage = (props: HeaderLandingPageProps) => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const navigate = useNavigate();

  const LandingPageHeaderOptions = [
    { label: i18n.t('landing.services'), to: () => props.scrollToServices() },
    {
      label: i18n.t('landing.ourRooms'),
      to: () => props.scrollToRooms(),
    },
    { label: i18n.t('landing.whereWeAre'), to: () => props.scrollToMap() },
    { label: i18n.t('landing.contacts'), to: () => props.scrollToFooter() },
  ];
  return (
    <>
      <HeaderStyled.Container container>
        <HeaderStyled.MobileMenuButton onClick={() => setDrawerOpen(true)}>
          <SvgImage type={SvgType.Hamburger} />
        </HeaderStyled.MobileMenuButton>
        <HeaderStyled.LogoContainer item md={3}>
          <SvgImage type={SvgType.LogoCsv} />
        </HeaderStyled.LogoContainer>

        <HeaderStyled.CentralContainer item md={6}>
          {LandingPageHeaderOptions.map((item, index) => (
            <HeaderStyled.OptionsLabels key={index} onClick={() => item.to()}>
              {item.label}
            </HeaderStyled.OptionsLabels>
          ))}
        </HeaderStyled.CentralContainer>

        <HeaderStyled.LoginContainer item md={3}>
          {/*<HeaderStyled.UserBox to={'/login'}>*/}
          {/*  <PersonIcon*/}
          {/*    sx={{*/}
          {/*      mr: 0.5,*/}
          {/*      mt: 0.2,*/}
          {/*      fontSize: { xs: 'x-large', md: 'large' },*/}
          {/*    }}*/}
          {/*  />*/}
          {/*  <HeaderStyled.Login>{i18n.t('landing.login')}</HeaderStyled.Login>*/}
          {/*</HeaderStyled.UserBox>*/}
          <HeaderStyled.ButtonBox>
            <HeaderStyled.Link to={'/login'}>
              <Button label={i18n.t('landing.reserveNow')} onClick={() => {}} />
            </HeaderStyled.Link>
          </HeaderStyled.ButtonBox>
        </HeaderStyled.LoginContainer>
        <Drawer
          anchor="left"
          open={drawerOpen}
          onClose={() => setDrawerOpen(false)}
        >
          <HeaderStyled.ListContainer>
            {LandingPageHeaderOptions.map((item, index) => (
              <ListItemButton
                key={index}
                onClick={() => {
                  item.to();
                  setDrawerOpen(false);
                }}
                component="a"
              >
                <ListItemText primary={item.label} />
              </ListItemButton>
            ))}
            <HeaderStyled.Link to={'/customer/booking'}>
              <Button label={i18n.t('landing.reserveNow')} onClick={() => {}} />
            </HeaderStyled.Link>
          </HeaderStyled.ListContainer>
        </Drawer>
      </HeaderStyled.Container>
    </>
  );
};

export default HeaderLandingPage;
